/* ─── Root ─── */

.root {
  position: relative;
  font-family: var(--font-sans);
}

/* ─── Track ─── */

.track {
  composes: scrollerX from "../../shared.module.css";
  gap: var(--carousel-gap, 0px);
  scroll-snap-type: x mandatory;
}

/* ─── Slide ─── */

.slide {
  flex: 0 0 var(--carousel-slide-width, 100%);
  scroll-snap-align: start;
}

/* ─── Navigation buttons ─── */

.navBtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  border: none;
  border-radius: var(--shape-full);
  background: var(--md-surface-container-low);
  color: var(--md-on-surface);
  box-shadow: var(--elevation-2);
  cursor: pointer;
  z-index: 1;
  opacity: 0;
  transition: opacity var(--motion-duration-short3)
    var(--motion-easing-standard);
}

@media (hover: hover) {
  .root:hover .navBtn {
    opacity: 1;
  }
}

.navBtn::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .navBtn:hover::before {
    opacity: var(--state-hover);
  }
}

.navBtn:focus-visible::before {
  opacity: var(--state-focus);
}

.navBtn:active::before {
  opacity: var(--state-pressed);
}

.navBtn:focus-visible {
  opacity: 1;
}

.navBtn:disabled {
  opacity: 0 !important;
  cursor: not-allowed;
}

.navBtn svg {
  width: 1rem;
  height: 1rem;
}

.prev {
  inset-inline-start: var(--space-2);
}

.next {
  inset-inline-end: var(--space-2);
}

/* Always visible on touch devices */
@media (hover: none) {
  .navBtn {
    opacity: 1;
  }

  .navBtn:disabled {
    opacity: 0.38 !important;
  }
}

/* ─── Dots ─── */

.dots {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-1);
  padding: var(--space-2) 0;
}

.dot {
  width: 8px;
  height: 8px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: var(--md-outline-variant);
  cursor: pointer;
  transition: width var(--motion-duration-short3) var(--motion-easing-standard),
    background var(--motion-duration-short3) var(--motion-easing-standard),
    border-radius var(--motion-duration-short3) var(--motion-easing-standard);
}

.dot:focus-visible {
  --focus-ring-offset: var(--focus-ring-offset-outset);
}

.dotActive {
  width: 24px;
  border-radius: var(--shape-full);
  background: var(--md-primary);
}

/* ─── Counter ─── */

.counter {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  color: var(--md-on-surface-variant);
}
